<template>
  <BaseModal
    :title="$t('end_match_confirm_title')"
    @close="cancelEndMatchConfirm"
  >
    <p class="confirm-text">
      {{ $t('end_match_confirm_body', { address }) }}
    </p>
    <div class="actions">
      <BaseButton class="warning" @click.native="confirmEndMatch">
        {{ $t('end_match_confirm_action') }}
      </BaseButton>
      <BaseButton class="grey outline" @click.native="cancelEndMatchConfirm">
        {{ $t('end_match_confirm_cancel') }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseModal from '@/components/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'EndMatchConfirmModal',

  components: {
    BaseModal,
    BaseButton
  },

  computed: {
    ...mapGetters({ endMatchConfirm: 'ui/endMatchConfirm' }),
    address() {
      return this.endMatchConfirm?.params?.address || '';
    }
  },

  methods: {
    ...mapActions({
      confirmEndMatch: 'ui/confirmEndMatch',
      cancelEndMatchConfirm: 'ui/cancelEndMatchConfirm'
    })
  }
};
</script>

<style lang="scss" scoped>
.confirm-text {
  margin: 0 0 24px;
  text-align: center;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
